import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { ErrorDispatcherService } from './error/error-dispatcher.service';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  constructor(private injector: Injector) {}

  public handleError(error: Error): void {
    if (/Loading chunk \d+ failed/.test(error?.message)) {
      window.location.reload();
    }
    this.injector.get(ErrorDispatcherService).handleError(error);
  }
}
